(function($){
  $(document).ready(function() {


    var iFocus = 1;
    var nbFocus = $('.les-focus .focus').length;


    function initBackgroundFocus(T) {
      if(0==nbFocus) return false;

      if (!Modernizr.objectfit) {
        iFocus = 1;
        backgroundFocus(T);
      }
    }


    function backgroundFocus(T) {
        var bandeau = $('#illufocus'+iFocus);
        var bg = bandeau.data('bgi');
        var goodBg = bg.replace('T4','T'+T);
        var imgSrc = goodBg.replace("url('",'').replace("')",'');
        var img = $("<img />").attr('src', imgSrc).on('load', function() {
          if (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0) {
              console.log('broken image!');
          } else {
              bandeau.css('background-image',goodBg);
              if(iFocus<nbFocus) {
                iFocus++;
                backgroundFocus(T);
              }
          }
        });
    }

    /*
    * Responsive JS
    * http://www.javascriptkit.com/javatutors/matchmediamultiple.shtml
    */
    const xsMin = 480, // phone landscape 480->767
        smMin = 768, // tablet portrait 768->1023
        mdMin = 1024, // tablet portrait
        lgMin = 1280,
        mqTelPortrait = 'only screen and (max-width: ' + (xsMin-1) + 'px)', // 0->479
        mqTelPaysage = 'only screen and (max-width: ' + (smMin-1) + 'px) and (min-width: ' + xsMin + 'px)', // 480->767
        mqTabletPortrait = 'only screen and (max-width: ' + (mdMin-1) + 'px) and (min-width: ' + smMin + 'px)', // 768->1023
        mqTabletPaysage = 'only screen and (max-width: ' + (lgMin-1) + 'px) and (min-width: ' + mdMin + 'px)', // 1024->1279
        mqOrdi = 'only screen and (min-width: ' + lgMin + 'px)', // 1280->++
        mqlist = [
            window.matchMedia(mqTelPortrait),
            window.matchMedia(mqTelPaysage),
            window.matchMedia(mqTabletPortrait),
            window.matchMedia(mqTabletPaysage),
            window.matchMedia(mqOrdi),
        ];

    const menu = $('#menu');
    const nav1 = $('.primary-header');
    const nav2 = $('.secondary-header');
    const recherche = $('#recherche');
    const formchercher = $('#formchercher');

    $('.primary-header .niv1 > .menu_item:not(:first-child) > .menu_link').click(function(e){
        e.preventDefault();
        $(this).parent().toggleClass('open').siblings().removeClass('open');
    })

    // const outils = $('.menu-outils');
    // const outilssticky = outils.stickybits({
    //     useStickyClasses: true,
    //     stickyBitStickyOffset: 80
    // });

    // Homélies - Timeline
    const homeliesSticky =  $('.menu_homelies').stickybits({
        useStickyClasses: true,
        stickyBitStickyOffset: 60,
    });

    function mediaqueryresponse(mql){
        // console.log(mql.media, mql.matches);
        const regexp_telPortrait = new RegExp('\\(max-width:\\s*' + (xsMin-1) + 'px\\)'),
              regexp_telPaysage = new RegExp('\\(max-width:\\s*' + (smMin-1) + 'px\\) and \\(min-width:\\s*' + xsMin + 'px\\)'),
              regexp_tabletPortrait = new RegExp('\\(max-width:\\s*' + (mdMin-1) + 'px\\) and \\(min-width:\\s*' + smMin + 'px\\)'),
              regexp_tabletPaysage = new RegExp('\\(max-width:\\s*' + (lgMin-1) + 'px\\) and \\(min-width:\\s*' + mdMin + 'px\\)'),
              regexp_ordi = new RegExp('\\(min-width:\\s*' + (lgMin) + 'px\\)');

        if (regexp_telPortrait.test(mql.media)){
            if (mql.matches){ // 320 -> 479
                // $('.primary-header .niv1 > .menu_item:not(:first-child) > .menu_link').click(function(e){
                //     e.preventDefault();
                //     $(this).parent().toggleClass('open').siblings().removeClass('open');
                // })
                $('.site-header').after(menu);
                formchercher.prependTo(recherche);
                nav1.after(recherche);
                initBackgroundFocus(4);
                homeliesSticky.update({stickyBitStickyOffset: 60});
            }
        }
        else if (regexp_telPaysage.test(mql.media)){
            if (mql.matches){ // 480 -> 767
                // $('.primary-header .niv1 > .menu_item:not(:first-child) > .menu_link').click(function(e){
                //     e.preventDefault();
                //     $(this).parent().toggleClass('open').siblings().removeClass('open');
                // })
                $('.site-header').after(menu);
                formchercher.prependTo(recherche);
                nav1.after(recherche);
                initBackgroundFocus(3);
                homeliesSticky.update({stickyBitStickyOffset: 60});
            }
        }
        else if (regexp_tabletPortrait.test(mql.media)){
            if (mql.matches){ // 768 -> 1023
                menu.appendTo($('.site-header-container'));
                recherche.appendTo(nav1);
                formchercher.appendTo($('body'));
                initBackgroundFocus(2);
                homeliesSticky.update({stickyBitStickyOffset: 100});
            }
        }
        else if (regexp_tabletPaysage.test(mql.media)){
            if (mql.matches){ // 1024 -> 1279
                initBackgroundFocus(1);
                menu.appendTo($('.site-header-container'));
                recherche.appendTo(nav1);
                formchercher.appendTo($('body'));
                homeliesSticky.update({stickyBitStickyOffset: 100});
            }
        }
        else if (regexp_ordi.test(mql.media)){
            if (mql.matches){ // 1280 -> *
                menu.appendTo($('.site-header-container'));
                recherche.appendTo(nav1);
                formchercher.appendTo($('body'));
                initBackgroundFocus(1);
                homeliesSticky.update({stickyBitStickyOffset: 100});
            }
        }
    }

    for (var i=0; i<mqlist.length; i++){
        mediaqueryresponse(mqlist[i]);
        mqlist[i].addListener(mediaqueryresponse);
    }

  })
})(jQuery);
